import { SoftpayLibrary } from '../../types/softpay';
import config, { ENV } from '../../config';

//@ts-ignore
const softpayLibrary = Softpay as SoftpayLibrary;

const getEnv = (env: ENV) => {
  if (env === 'prod') {
    return {
      pkg: 'io.softpay',
      pwa: true,
    };
  }
  return {
    pkg: 'io.softpay',
    env: 'sandbox',
    pwa: true,
  };
};

export const softpayClient =
  typeof softpayLibrary !== 'undefined'
    ? softpayLibrary.newClient({
        env: getEnv(config.env),
        callback: false,
      })
    : undefined;

export default softpayClient;
